import { useBoolean } from '@chakra-ui/react';
import React from 'react';
import FileViewer from '../../../components/pdf_viewer/FileViewer';
import { EyeAvatarIcon } from '../../../constants/IconData';
import { useAuditReportAttachment } from '../../../components/pdf_viewer/AuditReportViewer';
import { getDocumentViewerPath } from '../../../components/pdf_viewer/documentViewer.utils';

const FileViewAction = ({ auditUpload, chart_id=null }) => {
  const [isFileOpen, ifoState] = useBoolean(false);
  const { attachment } = useAuditReportAttachment({
    chartId: isFileOpen ? chart_id : null,
  });

  return (
    <React.Fragment>
      <EyeAvatarIcon
        style={{ cursor: 'pointer', width: '40px', height: '40px' }}
        onClick={ifoState.on}
        transition={'all .25s ease-in-out'}
      />
      <FileViewer
        isOpen={isFileOpen}
        currentFile={auditUpload?.file_obj}
        attachments={[
          ...(auditUpload?.attachments || []),
          ...(chart_id && attachment ? [attachment] : [])
        ]}
        viewerPath={getDocumentViewerPath({ chartId: chart_id })}
        chartId={auditUpload?.upload_id || auditUpload?.file_id || chart_id}
        onClose={ifoState.off}
      />
    </React.Fragment>
  );
};

export default FileViewAction;
